import { TablePagination } from '@octano/global-ui';
import { useStudentsRemovalRequestStudentstList } from './StudentsRemovalRequestStudentsListLoader';

export interface PerformanceAnalysisTablePaginationProps {
  total: number;
  totalPages: number;
}

export function StudentsRemovalRequestStudentsTablePagination({
  total,
  totalPages,
}: PerformanceAnalysisTablePaginationProps) {
  const { query, updateQuery } = useStudentsRemovalRequestStudentstList();

  return (
    <TablePagination
      pagination={{
        currentPage: query.page,
        itemsPerPage: 10,
        onChangePage: (page) => {
          updateQuery({ ...query, page });
        },
        totalItems: total,
        totalPages: totalPages,
      }}
    />
  );
}
